module.exports = {"firstname":"Vorname","lastname":"Nachname","address":"Adresse","addressExtraInformation":"Adresszusatz","zipcode":"Postleitzahl","city":"Ort","email":"Email","mobile":"Mobile","phone":"Telefon","website":"Website"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/guardian.json
// module id = vI1b
// module chunks = 1